import shape1 from '~/assets/images/shape1.png';
import shape2 from '~/assets/images/shape2.svg';
import shape3 from '~/assets/images/shape3.svg';
import shape4 from '~/assets/images/shape4.svg';
import shape5 from '~/assets/images/shape5.png';

const PageBanner = ({pageTitle}: {pageTitle: string}) => {
  return (
    <>
      <div
        className="page-title-area"
        style={{
          background: `transparent url('https://startp-next.envytheme.com/images/banner-bg1.jpg') 100% 0 no-repeat`,
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          paddingTop: 180,
          paddingBottom: 50,
        }}
      >
        <div className="d-table">
          <div className="d-table-cell">
            <div className="container">
              <h2>{pageTitle}</h2>
            </div>
          </div>
        </div>

        {/* Shape Images */}
        <div className="shape1">
          <img src={shape1} alt="shape" />
        </div>
        <div className="shape2 rotateme">
          <img src={shape2} alt="shape" />
        </div>
        <div className="shape3">
          <img src={shape3} alt="shape" />
        </div>
        <div className="shape4">
          <img src={shape4} alt="shape" />
        </div>
        <div className="shape5">
          <img src={shape5} alt="shape" />
        </div>
        <div className="shape6 rotateme">
          <img src={shape4} alt="shape" />
        </div>
        <div className="shape7">
          <img src={shape4} alt="shape" />
        </div>
        <div className="shape8 rotateme">
          {/* <img src={shape2} alt="shape" /> */}
        </div>
      </div>
    </>
  );
};

export default PageBanner;
